import { ApplicationState } from "../../store";
import { getIsUserAuthenticated } from "../../store/Login/selectors";
import { changeLanguage } from "../../store/LanguageLocale/actions";
import { connect } from "react-redux";
import { LanguageSelection } from "./LanguageSelection.component";
import { Dispatch } from "redux";
import { LanguageCodes } from "../../constants/languages";
import { ILanguageSelectionMapStateProps, ILanguageSelectionMapDispatchProps } from "./Types";

const mapStateToProps = (state: ApplicationState) => {
    return {
        lang: state.localeText.lang,
        isUserAuthenticated: getIsUserAuthenticated(state.login),
        useableLanguages: state.adminOptions.useableLanguages
    };
}

const mapDispatchToProps = (dispatch: Dispatch): ILanguageSelectionMapDispatchProps => ({
    changeLang: (lang: LanguageCodes) => {
        dispatch(changeLanguage(lang));
    }
});

export default connect<ILanguageSelectionMapStateProps, ILanguageSelectionMapDispatchProps, void>(mapStateToProps, mapDispatchToProps)(LanguageSelection);


// WEBPACK FOOTER //
// ./src/components/LanguageSelection/LanguageSelection.container.ts